import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        style: {
          backgroundColor: '#211F1C',
          color: '#F5F0EA',
          border: '1px solid rgba(245, 240, 234, 0.1)',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:shadow-lg",
          description: "group-[.toast]:!text-[#F5F0EA]/60",
          actionButton:
            "group-[.toast]:!bg-brand-teal group-[.toast]:!text-white",
          cancelButton:
            "group-[.toast]:!bg-[#EAE4DD] group-[.toast]:!text-[#1A1816]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
